<template>
    <!-- 订单-返程费-添加/编辑-订单模式编辑 -->
    <el-drawer
        title=""
        :visible.sync="show"
        :before-close="closeDialog"
        size="80%"
        class="order-detial-wrap"
        :show-close="false"
        destroy-on-close
        append-to-body
    >
        <div class="container pay" v-loading="modeLoading">
            <div>
                <div>订单模式:</div>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <div style="margin: 15px 0"></div>
                <el-checkbox-group v-model="checkedModes" @change="handleCheckedModesChange">
                    <el-checkbox v-for="(item, index) in modeAll" :label="item.order_mode.order_mode_code" :key="index">{{
                        item.name
                    }}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: center; margin-top: 10px">
            <el-button type="primary" @click="digSubmit">保存</el-button>
            <el-button @click="closeDialog">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
// var this;

export default {
    props: {
        isShow: Boolean,
        data: '',
        checkboxSelect: '' //添加和编辑页面公用一个子组件，传递该值用于区分是添加页面还是编辑页面，来确定修改父组件的值是添加还是编辑
    },
    watch: {
        isShow(newData, oldData) {
            this.show = true;
            this.modeLoading = true;

            // console.log(this.data.length, '子组件订单模式数量');
            // console.log(this.data, '子组件订单模式');
            this.checkedModes = this.data;

            this.orderModeList();
        }
    },

    data() {
        return {
            show: false,
            modeLoading: false,
            checkAll: false,
            isIndeterminate: false,
            checkedModes: [],
            modeAll: [],

            part_order_mode_code_array: [], //订单模式编码

            mode_options_data: {
                page: 1,
                limit: 50,
                status: ''
            },

            submit_rules: {
                part_order_mode_code_array: {
                    placeholder: '订单模式',
                    rules: {
                        required: true,
                        message: '请选择订单模式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        // this = this; 在列表点击添加页面的时候，进入添加页面，关闭添加页面后，
        //点击编辑页面，然后关闭编辑页面再次打开添加页面，没有调用creater生命周期，说明这次打开的是缓存，如果刷新页面在打开就调用created生命周期
        //当前存在一个bug，点击添加页面，然后点击添加页面的编辑按钮，关闭添加页面，点击编辑页面，然后点击编辑页面的编辑按钮，关闭编辑页面
        //再点击添加页面，点击添加页面的编辑按钮，就会发现，修改组件的订单模式后，添加页面没有跟着修改。就是因为this指向不一样了
    },

    methods: {
        // 保存
        digSubmit() {
            if (this.checkboxSelect == 'add') {
                this.$parent.$parent.checkedModes_add = this.checkedModes;
            }
            if (this.checkboxSelect == 'edit') {
                this.$parent.$parent.checkedModes_edit = this.checkedModes;
            }

            this.closeDialog();
        },
        // 全选
        handleCheckAllChange(val) {
            // console.log(this.checkedModes = val,'val');
            // this.checkedModes = val ? this.modeAll : [];
            // console.log(this.$refs.editMode,'this.$refs');
            if (val) {
                //全选
                let codeArray = [];

                for (let i = 0; i < this.modeAll.length; i++) {
                    codeArray.push(this.modeAll[i].order_mode.order_mode_code);
                }

                this.checkedModes = codeArray;
            } else {
                // 取消全选
                this.checkedModes = [];
            }

            this.isIndeterminate = false;
        },
        // 勾选订单模式
        handleCheckedModesChange(value) {
            // console.log(value, '勾选的value');
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.modeAll.length;
            // console.log(checkedCount, 'checkedCount');
            // console.log(this.modeAll.length, 'this.modeAll.length');
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.modeAll.length;
            // console.log(this.$refs.editModeE,'this.$refs');
            // console.log(this.isIndeterminate, 'this.isIndeterminate');
        },
        // 关闭方法
        closeDialog() {
            this.show = false;
            this.modeAll = [];
            this.checkedModes = [];
            this.modeLoading = false;
        },

        //获取订单模式
        orderModeList() {
            this.$post('/order/orderModeLists', this.mode_options_data)
                .then((res) => {
                    for (var i = 0; i < res.data.length; i++) {
                        this.modeAll.push(res.data[i]);
                    }

                    if (this.mode_options_data.page * this.mode_options_data.limit < res.count) {
                        this.mode_options_data.page += 1;
                        this.orderModeList();
                    } else {
                        this.mode_options_data.page = 1;
                    }

                    if (this.modeAll.length == res.count) {
                        // for 循环走完
                        // console.log(this.checkedModes.length, 'this.checkedModes.length');
                        // console.log(this.modeAll.length, 'this.modeAll.length');
                        if (this.checkedModes.length == this.modeAll.length) {
                            console.log('全选');
                            this.checkAll = true;
                            this.isIndeterminate = false;
                        } else {
                            this.checkAll = false;
                            this.isIndeterminate = true;
                        }
                        this.modeLoading = false;
                        // console.log(this.checkAll, 'this.checkAll==');
                    }
                })
                .catch((err) => {});
        }
    }
};
</script>

<style>
.container.pay .el-checkbox {
    width: 200px;
}
</style>






